window.RCV_ANGLES = {

  // Mirror Competitor - Drain Lymph
  // Ad copy: Dynamic (Scandinavian + 2-year window) | Image: Woman holding "HOW TO DRAIN LYMPH FLUID NATURALLY" sign
  'lymph-v1': {
    pdp_subhead:  'Naturally Drain Trapped Lymph Fluid In Just 15 Minutes A Day',
    pdp_tagline:  'Built for women who want to finally drain the fluid that keeps pooling while there is still time to reverse it.',
    adv_headline: 'Top Physical Therapist Reveals <strong>Why Compression Stockings Can\'t Move Trapped Lymph Fluid</strong> and the One Thing That Drains It Naturally',
    adv_mark:     'If you have swollen legs, puffy ankles, and shoes that pinch by dinner,',
    adv_tail:     ' read this short article right now before you do anything else.'
  },

  // Ticking Clock
  // Ad copy: Dynamic (Scandinavian + 2-year window) | Image: Woman at night, legs up, shoes pinching by dinner
  'clock-v1': {
    pdp_subhead:  'You Have a 2-Year Window to Reverse Your Leg Swelling. Most Women Miss It.',
    pdp_tagline:  'Built for women who know waiting another year is not an option.',
    adv_headline: 'Top Physical Therapist Reveals <strong>Why You Have a 2-Year Window To Reverse Your Leg Swelling</strong> Before It Becomes Permanent',
    adv_mark:     'If your legs are swollen by dinner and shoes that fit this morning are pinching by evening,',
    adv_tail:     ' read this short article right now because the window to reverse this is closing faster than you think.'
  },

  // Stocking
  // Ad copy: Dynamic (Scandinavian + 2-year window) | Image: Woman pulling on compression stocking
  'stk-v1': {
    pdp_subhead:  'Naturally Drain Trapped Lymph Fluid In Just 15 Minutes A Day',
    pdp_tagline:  'Built for women who want to finally drain the fluid that keeps pooling while there is still time to reverse it.',
    adv_headline: 'Top Physical Therapist Reveals <strong>Why Compression Stockings Can\'t Move Trapped Lymph Fluid</strong> and the One Thing That Drains It Naturally',
    adv_mark:     'If you have swollen legs, puffy ankles, and shoes that pinch by dinner,',
    adv_tail:     ' read this short article right now before you do anything else.'
  },

  // Close-up
  // Ad copy: Dynamic (Scandinavian + 2-year window) | Image: Extreme close-up of swollen ankle
  'closeup-v1': {
    pdp_subhead:  'Visibly Drain The Fluid Pooling In Your Ankles. In Just 15 Minutes A Day.',
    pdp_tagline:  'Built for women who are tired of watching the swelling build and ready for something that actually drains it.',
    adv_headline: 'Top Physical Therapist Reveals <strong>Why The Fluid Keeps Pooling In Your Ankles</strong> and the One Thing That Finally Drains It',
    adv_mark:     'If you can see the fluid pooling in your ankles and nothing you have tried actually drains it,',
    adv_tail:     ' read this short article right now before your next flare-up.'
  },

  // Home Ritual
  // Ad copy: Dynamic (Scandinavian + 2-year window) | Image: Woman at home entryway struggling to put on shoes
  'ritual-v1': {
    pdp_subhead:  'Drain Trapped Fluid At Home Tonight. In Just 15 Minutes Before Bed.',
    pdp_tagline:  'Built for women who want to handle this at home in 15 minutes without appointments, stockings, or complicated routines.',
    adv_headline: 'Top Physical Therapist Reveals <strong>Why The Fluid In Your Legs Builds Up From Morning To Night</strong> and the One Home Ritual That Drains It Before Bed',
    adv_mark:     'If you struggle to get your shoes on by evening because your feet and ankles are already swollen,',
    adv_tail:     ' read this short article right now because there is something simple you can do at home tonight.'
  },

  // Outdoor Life
  // Ad copy: Dynamic (Scandinavian + 2-year window) | Image: Woman gardening with swollen legs
  'outdoor-v1': {
    pdp_subhead:  'Drain The Fluid Slowing Your Legs Down. In Just 15 Minutes A Day.',
    pdp_tagline:  'Built for women who want their legs back so they can get back to the garden, the walks, and the life they love.',
    adv_headline: 'Top Physical Therapist Reveals <strong>Why Trapped Fluid Is Slowing Your Legs Down</strong> and the 15-Minute Method That Finally Drains It',
    adv_mark:     'If swollen, heavy legs are keeping you from gardening, walking, or doing the things you enjoy,',
    adv_tail:     ' read this short article right now before another season passes you by.'
  }

};